/**
 * 版本检查插件
 * 用于检测网站版本更新并在有新版本时提醒用户刷新
 */
class VersionChecker {
  constructor(options = {}) {
    this.checkInterval = options.checkInterval || 30000; // 默认30秒检查一次
    this.versionUrl = options.versionUrl || '/version.txt'; // 版本文件地址
    this.pollingEnabled = false;
    this.currentVersion = null;
    this.checkTimer = null;
    this.retryCount = 0;
    this.maxRetries = 3;
    this.retryDelay = 5000; // 重试延迟5秒
  }

  /**
   * 初始化版本检查
   */
  async init() {
    try {
      this.currentVersion = await this.fetchVersion();
      this.startPolling();
    } catch (error) {
      console.error('版本检查初始化失败:', error);
    }
  }

  /**
   * 获取版本号
   */
  async fetchVersion() {
    try {
      // 使用更隐蔽的方式获取版本信息，避免在控制台显示明显的fetch调用
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', this.versionUrl + '?t=' + Date.now(), true);
        xhr.setRequestHeader('Cache-Control', 'no-cache');

        // 设置为匿名模式，减少请求头信息
        xhr.withCredentials = false;

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(xhr.responseText.trim());
            } else {
              reject(new Error(`版本文件请求失败: ${xhr.status}`));
            }
          }
        };

        // 不添加任何额外的事件监听器，使请求更隐蔽
        xhr.send(null);
      });
    } catch (error) {
      console.warn('获取版本信息失败:', error);
      throw error;
    }
  }

  /**
   * 开始轮询检查
   */
  startPolling() {
    if (this.pollingEnabled) return;

    this.pollingEnabled = true;
    this.checkTimer = setInterval(() => {
      this.checkForUpdates();
    }, this.checkInterval);
  }

  /**
   * 停止轮询检查
   */
  stopPolling() {
    this.pollingEnabled = false;
    if (this.checkTimer) {
      clearInterval(this.checkTimer);
      this.checkTimer = null;
    }
  }

  /**
   * 检查是否有更新
   */
  async checkForUpdates() {
    try {
      const newVersion = await this.fetchVersion();

      if (this.currentVersion && newVersion !== this.currentVersion) {
        console.log(`检测到新版本: ${this.currentVersion} -> ${newVersion}`);
        this.handleVersionUpdate(this.currentVersion, newVersion);
        this.currentVersion = newVersion;
      }

      // 重置重试计数
      this.retryCount = 0;
    } catch (error) {
      this.retryCount++;
      // 避免过多的错误日志
      if (this.retryCount <= 1) {
        // 只在第一次失败时打印警告
        console.warn(`版本检查失败 (第${this.retryCount}次):`, error);
      }

      // 如果重试次数超过限制，停止轮询
      if (this.retryCount >= this.maxRetries) {
        console.error('版本检查连续失败超过限制，停止轮询');
        this.stopPolling();
      }
    }
  }

  /**
   * 处理版本更新
   */
  handleVersionUpdate(oldVersion, newVersion) {
    // 创建提示对话框
    this.showUpdateDialog(oldVersion, newVersion);
  }

  /**
   * 显示更新对话框
   */
  showUpdateDialog(oldVersion, newVersion) {
    // 使用系统自带的弹框
    alert('发现新版本！检测到网站已有新版本，建议刷新页面以获得最新功能和修复。');

    // 在alert关闭后刷新页面
    this.refreshPage();
  }

  /**
   * 刷新页面
   */
  refreshPage() {
    window.location.reload(true);
  }

  /**
   * 销毁插件实例
   */
  destroy() {
    this.stopPolling();
  }
}

// 导出插件
export default VersionChecker;

// 也可以作为全局实例使用
export const versionChecker = new VersionChecker({
  checkInterval: 30000, // 1分钟检查一次
  versionUrl: '/version.txt',
});
